import { render, staticRenderFns } from "./tpNF.vue?vue&type=template&id=5123a164&lang=html&"
import script from "./tpNF.vue?vue&type=script&lang=js&"
export * from "./tpNF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports